
























































import {Component, Emit, Vue, Prop} from 'vue-property-decorator';
import {loginModule} from '@/store/authentication/login';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';

import moment from 'moment';
import {払出修正候補編集レコード型} from '@/type/withdrawal/records/modify/払出修正候補編集レコード型';
import 払出修正候補編集入力チェッカー from '@/type/withdrawal/records/modify/払出修正候補編集入力チェッカー';

@Component({
  components: {
    ToggleButtonField,
    Datepicker,
    AmountField,
    AlertDialog,
  },
  filters: {
    日付のフォーマット(date: Date): string {
      if (!date) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class WithdrawalModification extends Vue {
  // data
  @Prop()
  value!: 払出修正候補編集レコード型;
  @Prop()
  rowIndex!: number;

  // computed
  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 有効期限管理をしない(): boolean {
    return loginModule.有効期限管理をしない;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  @Emit()
  clickRowSelect(): object {
    return {value: this.value};
  }

  @Emit()
  clickDeleteButton(): object {
    return {value: this.value};
  }

  確定対象ボタンを制御する(行番号: number): void {
    const current = this.value;
    if (current.修正されている()) {
      current.確定対象 = true;
      return;
    }
    current.確定対象 = false;
  }

  確定対象トグルボタンが無効である(value: 払出修正候補編集レコード型): boolean {
    return !value.修正されている();
  }

  get 払出日付Style(): object {
    return {alert: this.入力エラーが存在する('払出日')};
  }

  private 入力エラーが存在する(項目名: string): boolean {
    const checker = new 払出修正候補編集入力チェッカー();
    checker.validate(this.value, this.バラ管理である);
    return checker.hasError(項目名);
  }
}
